import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"

import AddReactionMutation from "@irati/recognition/apollo/mutation/AddReaction"
import Icon from "../Icons/IconWithReaction"
import hasReacted from "../../utils/feed/hasReacted"

class ReactionList extends Component {
  static propTypes = {
    comment: PropTypes.shape({
      reactions: PropTypes.shape({
        results: PropTypes.array
      }).isRequired
    }),
    item: PropTypes.shape({
      reactions: PropTypes.shape({
        results: PropTypes.array.isRequired
      }).isRequired
    })
  }

  static defaultProps = {
    comment: null,
    item: null
  }

  handleOnClick = (reaction, mutationOnClick) => {
    const {comment, item} = this.props

    if (!hasReacted({comment, item, reaction})) {
      mutationOnClick({native: "🐍"})
    }
  }

  render() {
    const {comment, item} = this.props
    const {reactions} = comment || item

    if (!reactions || !reactions.results) { return null }

    return (
      <Fragment>
        {reactions.results.map((reaction, i) =>
          <AddReactionMutation
            comment={comment}
            key={reaction.uuid || i}
            item={item}
            onCompleted={() => console.log("complete!")}
            onError={() => console.log("error")}>
            {(onClick) => (
              <Icon
                active={hasReacted({comment, item, reaction})}
                icon="comment"
                onClick={() => this.handleOnClick(reaction, onClick)}
                reaction={{
                  count: 3,
                  emoji: "🐍"
                }} />
            )}
          </AddReactionMutation>
        )}
      </Fragment>
    )
  }
}

export default ReactionList
